import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import TextInput from '../../components/form-fields/text.input';
import useApi from '../../hooks/use-api';
import Button from '../../components/button';
import Notice from '../../components/notice';
import MainContainer from '../containers/main';
import {
    API_STATUS_THROTTLING_ERROR,
    MESSAGE_IMIS_PASSWORD_RESET_ERROR,
    MESSAGE_THROTTLED_ERROR,
    MESSAGE_ACCOUNT_LOCKED_ERROR,
    API_STATUS_NOT_ALLOWED,
} from '../../constants';
import { getCaptchaToken, resetCaptcha } from '../../hooks/use-recaptcha';

const PasswordReset = () => {
    const api = useApi();

    const [submitting, setSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);
    const [resetComplete, setResetComplete] = useState(false);

    const [token, setToken] = useState(null);
    const [target, setTarget] = useState(null);

    const setRecaptchaToken = (captchaToken) => {
        setToken(captchaToken);
    };

    useEffect(() => {
        // Submitting is done in use effect, to ensure the recaptcha token is ready
        if (!target || !token) {
            return;
        }

        api.passwordReset(target.username.value, token).then(({ error: apiError }) => {
            if (apiError) {
                setSubmitting(false);
                setTarget(null);
                resetCaptcha();
                let infoMessage;
                switch (apiError.status) {
                case API_STATUS_NOT_ALLOWED:
                    infoMessage = MESSAGE_ACCOUNT_LOCKED_ERROR;
                    break;
                case API_STATUS_THROTTLING_ERROR:
                    infoMessage = MESSAGE_THROTTLED_ERROR;
                    break;
                default:
                    infoMessage = MESSAGE_IMIS_PASSWORD_RESET_ERROR;
                }
                setErrorMessage((
                    <Notice className="mt-2" color="yellow" icon="exclamation-orange">
                        <p>{ infoMessage }</p>
                    </Notice>
                ));
            } else {
                setResetComplete(true);
            }
        });
    }, [token]);

    window.setRecaptchaToken = setRecaptchaToken;

    const handleLogin = (e) => {
        setSubmitting(true);
        setErrorMessage(null);
        setTarget(e.target);

        getCaptchaToken();

        e.preventDefault();
    };

    return (
        <MainContainer>
            <>
                <h1>Reset password</h1>
                { resetComplete ? (
                    <>
                        <Notice className="mt-2" icon="ticked-circle-white" color="green">
                            <p>If you entered your username correctly, you will have received a link in your inbox. If you’re still having trouble, contact us at <a href="mailto:rnzcgp@rnzcgp.org.nz" className="no-underline color-green"><strong>rnzcgp@rnzcgp.org.nz</strong></a></p>
                        </Notice>
                    </>
                ) : (
                    <>
                        { errorMessage }
                        <p className="mt-4">Enter your username or MCNZ number and we will send you a link to reset your password.</p>
                        <form method="post" onSubmit={ handleLogin }>
                            <TextInput
                                label="Username or MCNZ number"
                                className="mt-4"
                                name="username"
                                placeholder="Eg. 123456"
                                required={ true }
                            />
                            <Button
                                text="Send password reset link"
                                className="mt-10 block btn--green-tint-3 mb-4"
                                disabled={ submitting }
                                loader={ submitting }
                            />
                        </form>
                        <Link to="/login/" className="small">Cancel</Link>
                    </>
                )}
            </>
        </MainContainer>

    );
};

export default PasswordReset;
